"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _brandSelection = require("@/api/brandSelection");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: [],
  data: function data() {
    return {
      taskId: '',
      dialogVisible1: false,
      radio: 1,
      fileList: [],
      ruleForm: {
        platformCode: '',
        goodsId: '',
        brandId: ''
      },
      options: [{
        name: '淘宝',
        id: 'TB'
      }, {
        name: '京东',
        id: 'JD'
      }, {
        name: '拼多多',
        id: 'PDD'
      }, {
        name: '抖音',
        id: 'DY'
      }, {
        name: '唯品会',
        id: 'WPH'
      }],
      rules: {
        platformCode: [{
          required: true,
          message: '请选择渠道平台',
          trigger: 'change'
        }],
        goodsId: [{
          required: true,
          message: '请输入商品ID',
          trigger: 'blur'
        }]
      },
      ossUrl: ''
    };
  },
  methods: {
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.ossUrl = '';
    },
    down: function down() {
      window.location.href = 'https://ugcore.oss-cn-hangzhou.aliyuncs.com/template/%E5%93%81%E7%89%8C%E7%B2%BE%E9%80%89%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx';
    },
    handleFileUpload1: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file, 'import');
            case 2:
              pictureUrl = _context.v;
              this.ossUrl = pictureUrl;
              this.fileList = [{
                name: file.name,
                url: pictureUrl
              }];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message({
                message: '上传失败',
                type: 'error'
              });
              this.handleRemove();
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload1(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload1;
    }(),
    open: function open(data) {
      console.log(data);
      this.clearIt();
      this.ruleForm.brandId = data.brandId;
      this.taskId = data.taskId;
      this.dialogVisible1 = true;
    },
    clearIt: function clearIt() {
      this.ruleForm = {
        platformCode: '',
        goodsId: '',
        brandId: ''
      };
      this.radio = 1;
      this.fileList = [];
      this.ossUrl = '';
    },
    onClose: function onClose() {
      this.clearIt();
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible1 = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.radio === 2) {
            console.log(_this.ruleForm);
            (0, _brandSelection.save_goods)((0, _objectSpread2.default)({}, _this.ruleForm)).then(function (res) {
              if (res.data) {
                _this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this.onClose();
                _this.$emit('refresh');
              }
            });
          } else {
            if (_this.fileList.length > 0 && _this.ossUrl) {
              console.log(_this.ossUrl);
              (0, _brandSelection.import_file)({
                moduleId: 2,
                taskId: _this.taskId,
                filePath: _this.ossUrl,
                fileName: _this.fileList[0].name
              }).then(function (res) {
                if (res.data) {
                  _this.$notify.success({
                    title: '温馨提示',
                    message: '操作成功'
                  });
                  _this.onClose();
                  _this.$emit('refresh');
                }
              });
            } else {
              _this.$message({
                message: '请上传文件！',
                type: 'error'
              });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};